import { render, staticRenderFns } from "./TraficCard.vue?vue&type=template&id=30040132"
import script from "./TraficCard.vue?vue&type=script&lang=js"
export * from "./TraficCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports